<template>
  <ankh-list>
    <template #btn-group>
      <el-button icon="el-icon-delete" @click.native="handleBatchDelete">批量删除</el-button>
    </template>
    <template #search-form>
      <el-form-item label="菜谱编号">
        <el-input placeholder="菜谱编号" v-model="searchForm.num" clearable/>
      </el-form-item>
      <el-form-item label="菜谱名称">
        <el-input placeholder="菜谱名称" v-model="searchForm.name" clearable/>
      </el-form-item>

      <el-form-item label="发布者编号">
        <el-input placeholder="发布者编号" v-model="searchForm.userNum" clearable/>
      </el-form-item>

      <el-form-item label="发布者昵称">
        <el-input placeholder="发布者昵称" v-model="searchForm.username" clearable/>
      </el-form-item>

      <el-form-item>
        <el-button type="primary" @click="$refs.list.handleSearch()">搜索</el-button>
        <el-button @click="$refs.list.reset()">重置</el-button>
      </el-form-item>
    </template>

    <template #table="{height}">

      <table-list
          :height="height"
          ref="list"
          row-key="id"
          @query="handleSearch"
          :request-params="{num: $route.query.num}"
          :search-params="searchForm"
          :data="tableData"
          :indent="16"
          @selection-change="selection = $event">

        <el-table-column type="selection" width="50"/>
        <el-table-column prop="num" label="编号"/>
        <el-table-column prop="phone" label="图片">
          <template v-slot="{row}">
            <div class="fb-gap-10">
              <preview-img :img-url="row.cover" :size="40" :length="2" />
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="name" label="名称"/>
        <el-table-column prop="userNum" label="发布者编号"/>
        <el-table-column label="发布者昵称" prop="username" />
        <el-table-column label="文字相似度" prop="textSamePercent" />
        <el-table-column label="食材相似度" prop="foodSamePercent" />
<!--        <el-table-column label="上架时间">
          <template v-slot="{row}">
            {{ row.createTime | formatDate}}
          </template>
        </el-table-column>-->
<!--        <el-table-column label="菜谱相似度" />-->
        <el-table-column fixed="right" label="操作" width="90">
          <template v-slot="{row}">
            <div class="fb-link-flex">
              <el-link type="danger" :underline="false" @click="handleDelete">删除</el-link>
            </div>
          </template>
        </el-table-column>
      </table-list>
    </template>
  </ankh-list>
</template>

<script>
import {request, requestByTip} from "@/config/request";
import TableList from "@/components/table-list/TableList";
import AnkhList from "@/components/list/AnkhList.vue";
import PreviewImg from "@/components/preview-img/PreviewImg.vue";

export default {
  name: "SimilarRecipeList",
  components: {PreviewImg, AnkhList, TableList},
  data() {
    return {
      searchForm: {},
      tableData: [],
      selection: [],
    }
  },
  methods: {
    async handleDelete(row) {
      try {
        await requestByTip(this.$api.cookbook.delete, {code: row.code});
        this.$message.success("操作成功")
        this.$refs.list.handleRequest();
      } catch (e) {
        console.error(e);
      }
    },

    async handleBatchDelete() {
      if (!this.selection.length) {
        this.$message({
          type: 'warning',
          message: '未选择记录'
        });
        return;
      }
      try {
        let codes = this.selection.map(item => item.code);
        await requestByTip(
            this.$api.test.list,
            codes,
            {isJson: true},
            {message: "您现在正在进行批量删除操作, 是否继续?"}
        );
        this.$message.success("操作成功");
        this.$refs.list.handleRequest();
      } catch (e) {
        console.error(e);
      }
    },

    async handleSearch(params) {
      try {
        let res = await request(this.$api.cookbook.listSame, params, {isJson: true});
        for (let key in res) {
          if (res[key] instanceof Array) {
            this.tableData = res[key];
          }
        }
        if (this.$refs?.list) {
          this.$refs.list.setTotal(res.pager?.itemCount);
        }
      } catch (e) {
        console.error(e);
      }
    }
  },
}
</script>

<style scoped>

</style>
